var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C19.3137 0 22 2.68629 22 6V16C22 19.3137 19.3137 22 16 22H6C2.68629 22 9.66416e-08 19.3137 0 16V6C0 2.68629 2.68629 9.66384e-08 6 0H16ZM11.5449 12.666C11.3904 12.8253 11.1808 12.9141 10.9629 12.9141C10.745 12.9141 10.5354 12.8253 10.3809 12.666L4.42871 6.5127C4.41044 6.58236 4.40126 6.65438 4.40039 6.72656V15.2783C4.40043 15.505 4.48695 15.7225 4.6416 15.8828C4.79623 16.0431 5.00595 16.1337 5.22461 16.1338H16.7754C16.9941 16.1337 17.2038 16.0431 17.3584 15.8828C17.5131 15.7225 17.5996 15.505 17.5996 15.2783V6.72656C17.5963 6.6376 17.5802 6.54945 17.5508 6.46582L11.5449 12.666ZM8.79688 12.1865L5.79004 15.2783H5.2168V14.667L8.21582 11.584L8.79688 12.1865ZM16.7627 14.667L16.7666 15.2783H16.1895L13.1816 12.1865L13.7637 11.584L16.7627 14.667ZM16.7705 5.87109H5.2207C5.14673 5.87229 5.07297 5.88377 5.00195 5.90527L10.9629 12.0586L16.9404 5.87109C16.8842 5.86509 16.8267 5.86509 16.7705 5.87109Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.797a05c9bf828054710cbba4e063047f.svg";
export { ForwardRef as ReactComponent };